const line_item_list_template = `
<div class="list-view">
        <div class="line-item header">
            <span class="date-column">Date (UTC)</span>
            <span class="charge">{{#if credit}}Credit{{else}}Charge{{/if}}</span>
            <span class="event">Event</span>
            <span class="qty">QTY</span>
            <span class="description">Description</span>
            <span class="details">Details</span>
        </div>
</div>
<div class="list-view content">
    <div class="loading text-center">loading</div>
</div>
`;

import Radio from 'backbone.radio';
import Backbone from 'backbone';
import Marionette from 'backbone.marionette';
import Handlebars from 'handlebars';
import LineItem from '@/views/list_item/billing_line_item';

const LineItemListView = Marionette.CollectionView.extend({
    template: Handlebars.compile(line_item_list_template),
    className: 'list',
    childView: LineItem
});

const LineItemListContainer = Marionette.View.extend({
    template: Handlebars.compile(line_item_list_template),
    regions: {
        list_view : '.list-view.content',
    },
    className: 'line-item-list',
    prep_list: function(items) {
        if ( !items ) return;
        let account = Radio.request('global', 'primary_account');

        if ( items && items.length > 0 ) {
            let last = items.length -  1;
            let last_item = items[last];

            account.get_usage(last_item.attributes.created_at, items[0].attributes.created_at)
            .then( (resp) => {
                const details = resp;
                this.render_list(items, details);
            }, (err) => {
                Radio.request('alerts', 'response_dialog', err, 'error', 'Could not retreive usage information', 'Account ID ' + account.id);
                this.render_empty_items_list();
            });
        } else {
            this.render_empty_items_list();
        }
    },
    render_list: function(items, details) {
        if ( !items ) return; 
        if ( items.length === 0 ) {
            this.render_empty_items_list();
        }
        items.forEach( (item, i)=> {
            if ( details ) {
                item.attributes.details = [];
                let dets = details.filter(
                    (d) => {
                        return d.cell_conn_count > 0 
                            && d.created_at >= item.attributes.created_at
                            && ( items[i+1] === undefined
                            || d.created_at < items[i+1].attributes.created_at );
                    }
                );
                dets.forEach( (det) => { items[i].attributes.details.push(det); } );
            }
        });

        let collection = new Backbone.Collection(items);

        this.showChildView('list_view', new LineItemListView({
            collection
        }));
    },
    render_empty_items_list: function() {
        if ( this.options.emptyView ) {
            this.showChildView('list_view', new this.options.emptyView );
        } else {
            this.showChildView('list_view', new Marionette.View({ template: '<div class="empty"><h4 class="text-center">no items to display</h4></div>' }));
        }
    }
});



export default LineItemListContainer;
